import { alpha } from "@mui/system";

const styles = (theme) => ({
  title: { fontWeight: "bold", fontSize: "20px" },
  containerHeader: {
    p: 1,
  },
  paperBody: {
    p: 2,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    backgroundColor: theme.palette.background.wallpaper,
  },
  paperContainer: {
    p: 1,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  boxContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 2,
  },
  boxHeaderBlock: {
    pt: 0.5,
  },
  titleSwitch: {
    fontWeight: 600,
    ml: 1,
    fontSize: "0.85rem",
    userSelect: "none",
  },
  subtitle: {
    fontWeight: "bold",
    fontSize: "10px",
    color: theme.palette.text.secondary,
    ml: 1,
  },
  boxFiltros: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    width: { xs: "100%", sm: "auto" },
  },
  origemField: {
    width: { xs: "100%", sm: "170px" },
    "& .MuiSelect-select": { fontSize: "0.85rem" },
  },
  searchField: {
    width: { xs: "100%", sm: "320px" },
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "520px",
  },
  paperInfo: {
    p: 1.5,
    flex: 1,
    borderRadius: "8px",
    bgcolor: "action.hover",
    display: "flex",
    alignItems: "center",
    borderStyle: "dashed",
  },
  textInfo: {
    fontSize: "13px",
    color: "text.secondary",
    lineHeight: 1.4,
  },
  containerActions: {
    p: "10px 15px",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    display: "flex",
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  textPendente: {
    fontSize: "13px",
    color: "text.secondary",
    lineHeight: 1.4,
    mr: "auto",
  },
  chip: { fontSize: "11px", fontWeight: "bold" },
  chipEmUso: {
    height: 20,
    fontSize: "11px",
    fontWeight: "bold",
  },
  optionGroup: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: 1,
    mx: 1,
  },
  optionCard: (selected, disabled) => ({
    p: 1.5,
    borderRadius: "12px",
    cursor: disabled ? "default" : "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    opacity: disabled && !selected ? 0.6 : 1,
    borderColor: selected ? "primary.main" : "divider",
    bgcolor: selected
      ? alpha(
          theme.palette.primary.main,
          theme.palette.mode === "dark" ? 0.1 : 0.05,
        )
      : "background.paper",
    transition: "all .15s ease",
    "&:hover": {
      borderColor: selected
        ? "primary.main"
        : disabled
          ? "divider"
          : "text.disabled",
    },
  }),
  datagridConfortavel: (alturaLinha) => ({
    "& .MuiDataGrid-row": {
      minHeight: `${alturaLinha}px !important`,
      maxHeight: `${alturaLinha}px !important`,
    },
    "& .MuiDataGrid-cell": {
      py: 1,
      px: 1.5,
      fontSize: "0.85rem",
      display: "flex",
      alignItems: "center",
      borderTop: `0.2px solid ${
        theme.palette.mode === "dark"
          ? theme.palette.secondary.dark
          : theme.palette.secondary.lighter
      } !important`,
    },
    "& .MuiDataGrid-columnHeader": {
      px: 1.5,
      fontSize: "0.75rem",
      color:
        theme.palette.mode === "dark"
          ? theme.palette.secondary.light
          : theme.palette.secondary.dark,
    },
  }),
  boxOrigem: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 0.5,
  },
  boxNomes: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 0.5,
  },
  codigoCliente: {
    fontSize: "0.8rem",
    fontWeight: 600,
    fontVariantNumeric: "tabular-nums",
  },
  nomeCliente: (ativo) => ({
    fontSize: "0.8rem",
    fontWeight: ativo ? 700 : 400,
    color: ativo ? "text.primary" : "text.disabled",
  }),
  nomeTag: (ativo) => ({
    display: "inline-block",
    fontSize: "10px",
    fontWeight: 700,
    px: 0.6,
    py: "1px",
    mr: 1,
    borderRadius: "4px",
    bgcolor: ativo ? alpha(theme.palette.primary.main, 0.14) : "action.hover",
    color: ativo ? "primary.main" : "text.disabled",
  }),
  select: {
    fontSize: "0.85rem",
    borderRadius: "8px",
    bgcolor: "background.paper",
    "& .MuiSelect-select": { py: 1 },
  },
  menuItem: { fontSize: "0.85rem" },
});

export default styles;
